<template>
	<div id="modal2" class="modal" v-bind:class="{ show: modal2 == true }">
		<div class="modal-dim"></div>
		<div class="modal-con inquiry">
			<button type="button" class="btn btn-close" @click="closeModal"></button>
			<div class="inquiry-scroll--wrap">
				<div class="inquiry-scroll" ref="scrollBody">
					<div class="inquiry-scroll--bar"></div>
					<!-- <div class="inquiry-left">
						<div class="text">
							<div class="name">위온어스(WE’ONUS)</div>
							<div class="box">
								<div class="text">문의 유형을 선택해주세요.</div>
								<div class="input">
									<div class="button-list border-none type2">
										<button
											type="button"
											class="btn btn-md"
											v-bind:class="{ 'btn-primary': mode == 'main_lessee', 'btn-grey': mode != 'main_lessee' }"
											@click="setMode('main_lessee')"
										>
											임차인이에요
										</button>
										<button
											type="button"
											class="btn btn-md"
											v-bind:class="{ 'btn-primary': mode == 'main_landlord', 'btn-grey': mode != 'main_landlord' }"
											@click="setMode('main_landlord')"
										>
											임대인이에요
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="level >= 2" class="inquiry-right">
						<div v-if="mode == 'main_lessee'" class="text">임차인이에요</div>
						<div v-else class="text">임대인이에요</div>
					</div> -->
					<div v-if="level >= 2" class="inquiry-left">
						<div class="text">
							<div class="name">위온어스(WE’ONUS)</div>
							<div class="box">
								<div class="text">휴대폰 인증을 해주세요.</div>
								<div class="input">
									<div class="button-exist">
										<input
											type="tel"
											class="input-text"
											v-model="dataInfo.phone"
											:disabled="optSt"
											@keyup="getPhoneMask(dataInfo.phone)"
										/>
										<button type="button" class="btn btn-primary btn-md" @click="sendOtp" :disabled="optSt">
											인증번호 전송
										</button>
									</div>
									<div class="button-exist">
										<span class="time">{{ TimerStr }}</span>
										<input
											type="text"
											class="input-text"
											placeholder="인증번호 입력"
											v-model="optNumber"
											:disabled="!optSt || level >= 3"
										/>
										<button
											type="button"
											class="btn btn-primary btn-md"
											@click="checkOtp"
											:disabled="!optSt || level >= 3"
										>
											인증 확인
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="level >= 3" class="inquiry-right">
						<div class="text">인증완료</div>
					</div>
					<div v-if="level >= 3" class="inquiry-left">
						<div class="text">
							<div class="name">위온어스(WE’ONUS)</div>
							<div class="box">
								<div class="text">이메일 주소를 입력해주세요.</div>
								<div class="input">
									<div class="button-exist">
										<input type="text" class="input-text" v-model="dataInfo.email" :disabled="level >= 4" />
										<button type="button" class="btn btn-primary btn-md" :disabled="level >= 4" @click="nextLevel">
											확인
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="level >= 4" class="inquiry-right">
						<div class="text">{{ dataInfo.email }}</div>
					</div>
					<div v-if="level >= 4" class="inquiry-left">
						<div class="text">
							<div class="name">위온어스(WE’ONUS)</div>
							<div class="box">
								<div class="text">어느 지역을 선호하시나요?</div>
								<div class="input">
									<div class="select-list">
										<select class="input-select type2" :disabled="level >= 5">
											<option>시/도 선택</option>
										</select>
										<select class="input-select type2" :disabled="level >= 5">
											<option>시/군/구 선택</option>
										</select>
										<select class="input-select type2" :disabled="level >= 5">
											<option>읍/면/동 선택</option>
										</select>
									</div>
									<div class="button-only">
										<button type="button" class="btn btn-primary btn-md" :disabled="level >= 5" @click="nextLevel">
											확인
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="level >= 5" class="inquiry-right">
						<div class="text">{{ dataInfo.address }}</div>
					</div>
					<div v-if="level >= 5" class="inquiry-left">
						<div class="text">
							<div class="name">위온어스(WE’ONUS)</div>
							<div class="box">
								<div class="text">매입하시려는 목적은 무엇인가요? (중복 선택 가능)</div>
								<div class="input">
									<div class="flex3">
										<div class="col">
											<label class="input-checkbox">
												<input type="checkbox" v-model="dataInfo.ckOfiice" :disabled="level >= 6" />
												<span class="label">사옥</span>
											</label>
											<label class="input-checkbox">
												<input type="checkbox" v-model="dataInfo.ckInvest" :disabled="level >= 6" />
												<span class="label">투자</span>
											</label>
										</div>
										<div class="col">
											<input
												type="number"
												class="input-text"
												placeholder="필요한 연면적"
												:disabled="!dataInfo.ckOfiice || level >= 6"
												v-model="dataInfo.totalPy"
											/>
											<span class="text">평</span>
										</div>
										<div class="col">
											<input
												type="number"
												class="input-text"
												placeholder="필요한 대지면적"
												:disabled="!dataInfo.ckOfiice || level >= 6"
												v-model="dataInfo.landPy"
											/>
											<span class="text">평</span>
										</div>
									</div>
									<div class="button-only">
										<button type="button" class="btn btn-primary btn-md" :disabled="level >= 6" @click="checkPy">
											확인
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="level >= 6" class="inquiry-right">
						<div class="text">
							<template v-if="dataInfo.ckOfiice">
								사옥(연면적 {{ dataInfo.totalPy }}평/대지면적 {{ dataInfo.landPy }}평)
							</template>
							<template v-if="dataInfo.ckOfiice && dataInfo.ckInvest">,</template>
							<template v-if="dataInfo.ckInvest"> 투자 </template>
						</div>
					</div>
					<div v-if="level >= 6" class="inquiry-left">
						<div class="text">
							<div class="name">위온어스(WE’ONUS)</div>
							<div class="box">
								<div class="text">희망하는 물건의 유형을 골라주세요.</div>
								<div class="input">
									<div class="button-list">
										<button
											type="button"
											class="btn btn-md"
											v-bind:class="{ 'btn-primary': typeList[0], 'btn-grey': !typeList[0] }"
											@click="checkType('높은 임대수익', 0)"
										>
											높은 임대수익
										</button>
										<button
											type="button"
											class="btn btn-primary btn-md"
											v-bind:class="{ 'btn-primary': typeList[1], 'btn-grey': !typeList[1] }"
											@click="checkType('신축/재건축 가능', 1)"
										>
											신축 / 재건축<br />가능 토지
										</button>
										<button
											type="button"
											class="btn btn-primary btn-md"
											v-bind:class="{ 'btn-primary': typeList[2], 'btn-grey': !typeList[2] }"
											@click="checkType('신축건물', 2)"
										>
											신축건물
										</button>
										<button
											type="button"
											class="btn btn-primary btn-md"
											v-bind:class="{ 'btn-primary': typeList[3], 'btn-grey': !typeList[3] }"
											@click="checkType('리모델링', 3)"
										>
											리모델링
										</button>
									</div>
									<div class="button-exist">
										<input
											type="text"
											class="input-text"
											placeholder="직접입력"
											v-model="typeList[4]"
											:disabled="level >= 7"
										/>
										<button
											type="button"
											class="btn btn-primary btn-md"
											:disabled="
												(!typeList[0] && !typeList[1] && !typeList[2] && !typeList[3] && !typeList[4]) || level >= 7
											"
											@click="nextLevel"
										>
											확인
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="level >= 7" class="inquiry-right">
						<div class="text">
							<template v-for="(item, idx) in dataInfo.type">
								{{ item }}{{ dataInfo.type.length > 0 && idx < dataInfo.type.length - 1 ? ', ' : '' }}
							</template>
						</div>
					</div>
					<div v-if="level >= 7" class="inquiry-left">
						<div class="text">
							<div class="name">위온어스(WE’ONUS)</div>
							<div class="box">
								<div class="text">보유하고 있는 현금이 얼마인가요?</div>
								<div class="input">
									<div class="button-exist">
										<span class="time type2">억 원</span>
										<input
											type="number"
											class="input-text"
											placeholder="ex)20"
											v-model="dataInfo.money"
											:disabled="level >= 8"
										/>
										<button
											type="button"
											class="btn btn-primary btn-md"
											:disabled="!dataInfo.money || level >= 8"
											@click="nextLevel"
										>
											확인
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="level >= 8" class="inquiry-right">
						<div class="text">{{ dataInfo.money }}억</div>
					</div>
					<div v-if="level >= 8" class="inquiry-left">
						<div class="text">
							<div class="name">위온어스(WE’ONUS)</div>
							<div class="box">
								<div class="text">어느정도 대출을 생각하시나요?</div>
								<div class="input">
									<div class="button-list border-none">
										<button
											type="button"
											class="btn btn-md"
											v-bind:class="{ 'btn-primary': dataInfo.loan == 30, 'btn-grey': dataInfo.loan != 30 }"
											@click="checkLoan(30)"
										>
											30%
										</button>
										<button
											type="button"
											class="btn btn-md"
											v-bind:class="{ 'btn-primary': dataInfo.loan == 50, 'btn-grey': dataInfo.loan != 50 }"
											@click="checkLoan(50)"
										>
											50%
										</button>
										<button
											type="button"
											class="btn btn-md"
											v-bind:class="{ 'btn-primary': dataInfo.loan == 70, 'btn-grey': dataInfo.loan != 70 }"
											@click="checkLoan(70)"
										>
											70%
										</button>
										<button
											type="button"
											class="btn btn-md"
											v-bind:class="{ 'btn-primary': dataInfo.loan == 'any', 'btn-grey': dataInfo.loan != 'any' }"
											@click="checkLoan('any')"
										>
											상관없음
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="level >= 9" class="inquiry-right">
						<div class="text">
							{{ dataInfo.loan == 'any' ? '상관없음' : dataInfo.loan + '%' }}
						</div>
					</div>
					<div v-if="level >= 9" class="inquiry-left">
						<div class="text">
							<div class="name">위온어스(WE’ONUS)</div>
							<div class="box">
								<div class="text">
									건물을 찾고 계시는군요?
									<div class="badge-wrap">
										<span class="badge">{{ dataInfo.address }}</span>
										<span v-if="dataInfo.ckOfiice" class="badge"
											>사옥(연면적{{ dataInfo.totalPy }}평/대지면전{{ dataInfo.landPy }}평)</span
										>
										<span v-if="dataInfo.ckInvest" class="badge">투자</span>
										<span v-for="(item, idx) in dataInfo.type" :key="'type_did_' + idx" class="badge">{{ item }}</span>
										<span class="badge">현금 {{ dataInfo.money }}억</span>
										<span class="badge">대출 {{ dataInfo.loan == 'any' ? '상관없음' : dataInfo.loan + '%' }}</span>
									</div>
									<div class="result">
										전체 10,523건 중 적합한 물건 <strong class="type2">12건</strong>의 매물이 발견되었어요. <br />
										<strong>담당 PM이 1시간이내로 연락드리겠습니다.</strong>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-show="false" ref="bottomScroll"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: { st: { type: Boolean } },
	name: 'MainModal',
	components: {},
	computed: {},
	watch: {
		st() {
			this.modal2 = this.st;
		},
	},
	data() {
		return {
			level: 2,
			mode: null,
			dateData: null,
			modal2: false,
			v_date: '2023/12/04',
			optNumber: null,
			optSt: false,
			dataInfo: {
				phone: '',
				email: '',
				address: '서울 강남구 논현동',
				ckOfiice: false,
				ckInvest: false,
				totalPy: null,
				totalM2: null,
				landPy: null,
				landM2: null,
				type: [],
				money: null,
				loan: null,
			},
			typeList: ['', '', '', '', ''],
			Timer: null,
			TimeCounter: 180,
			TimerStr: '03:00',
		};
	},
	created() {
		this.modal2 = this.st;
	},
	unmounted() {
		clearInterval(this.Timer);
	},
	methods: {
		closeModal() {
			this.modal2 = false;
			this.$emit('closeModal');
		},
		btnOnDate() {
			console.log(this.dateData.getDate('yyyy년 mm월 dd일'));
		},
		setMode(mode) {
			if (this.mode) {
				return;
			}
			this.mode = mode;
			this.nextLevel();
		},
		sendOtp() {
			if (!this.dataInfo.phone.length) {
				alert('휴대폰번호를 입력해주세요.');
				return;
			}

			this.$apiGET('/users/cert?phone=' + this.dataInfo.phone).then(() => {
				this.optSt = true;
				this.Timer = this.timerStart();
			});
			// this.optSt = true;
			// this.Timer = this.timerStart();
		},
		checkOtp() {
			this.timerStop(this.Timer);
			this.Timer = null;

			this.$apiGET('/users/cert/check?phone=' + this.dataInfo.phone + '&keyNum=' + this.optNumber).then(re => {
				if (re) {
					this.timerStop(this.Timer);
					this.Timer = null;
					this.nextLevel();
				} else {
					this.$apiPOST('/users/cert/del', { phone: this.dataInfo.phone }).then();

					alert('잘못된 인증번호 입니다. 다시 시도해주세요.');
					this.TimerStr = '03:00';
					this.optSt = false;
				}
			});
		},
		checkPy() {
			if (!this.dataInfo.ckOfiice && !this.dataInfo.ckInvest) {
				alert('목적을 선택해주세요.');
				return;
			} else if (this.dataInfo.ckOfiice) {
				if (!this.dataInfo.totalPy) {
					alert('연면적을 입력해주세요.');
					return;
				} else if (!this.dataInfo.landPy) {
					alert('대지면적을 입력해주세요.');
					return;
				}
			}

			this.nextLevel();
		},
		checkType(val, idx) {
			if (this.level >= 7) {
				return;
			}

			if (this.typeList[idx] == val) {
				this.typeList[idx] = '';
			} else {
				this.typeList[idx] = val;
			}
		},
		checkLoan(val) {
			if (this.dataInfo.loan) {
				return;
			}
			this.dataInfo.loan = val;

			this.nextLevel();
		},
		nextLevel() {
			if (this.level == 1) {
				this.level = 2;
			} else if (this.level == 2) {
				this.level = 3;
			} else if (this.level == 3) {
				if (!this.$vaileEmail(this.dataInfo.email)) {
					alert('이메일 형식으로 입력해주세요.');
					return;
				}
				this.level = 4;
			} else if (this.level == 4) {
				if (!this.dataInfo.address?.length) {
					alert('주소를 입력해주세요.');
					return;
				}
				this.level = 5;
			} else if (this.level == 5) {
				this.level = 6;
			} else if (this.level == 6) {
				this.dataInfo.type = [];
				for (let i = 0; i < this.typeList.length; i++) {
					if (this.typeList[i]) {
						this.dataInfo.type.push(this.typeList[i]);
					}
				}
				this.level = 7;
			} else if (this.level == 7) {
				this.level = 8;
			} else if (this.level == 8) {
				this.level = 9;
			}
			this.moveScroll();
		},
		moveScroll() {
			this.$nextTick(() => {
				this.$refs['bottomScroll'].scrollIntoView(false, { behavior: 'smooth', block: 'start' });
				this.$refs.scrollBody.scrollTo({ left: 0, top: this.$refs.scrollBody.scrollHeight, behavior: 'smooth' });
				// this.$refs.scrollBody.scrollTop = this.$refs.scrollBody.scrollHeight;
			});
		},
		getPhoneMask(phoneNumber) {
			if (!phoneNumber) return phoneNumber;
			phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

			let res = '';
			if (phoneNumber.length < 3) {
				res = phoneNumber;
			} else {
				if (phoneNumber.substr(0, 2) == '02') {
					if (phoneNumber.length <= 5) {
						//02-123-5678
						res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 3);
					} else if (phoneNumber.length > 5 && phoneNumber.length <= 9) {
						//02-123-5678
						res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 3) + '-' + phoneNumber.substr(5);
					} else if (phoneNumber.length > 9) {
						//02-1234-5678
						res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 4) + '-' + phoneNumber.substr(6);
					}
				} else {
					if (phoneNumber.length < 8) {
						res = phoneNumber;
					} else if (phoneNumber.length == 8) {
						res = phoneNumber.substr(0, 4) + '-' + phoneNumber.substr(4);
					} else if (phoneNumber.length == 9) {
						res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6);
					} else if (phoneNumber.length == 10) {
						res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6);
					} else if (phoneNumber.length > 10) {
						//010-1234-5678
						res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 4) + '-' + phoneNumber.substr(7);
					}
				}
			}

			this.dataInfo.phone = res;
		},
		timerStart() {
			// 1초에 한번씩 start 호출
			this.TimeCounter = 180;
			var interval = setInterval(() => {
				this.TimeCounter--; //1초씩 감소
				this.TimerStr = this.prettyTime();
				if (this.TimeCounter <= 0) {
					this.timerStop(interval);
					this.TimerStr = '03:00';
					this.Timer = null;
					this.optSt = false;
					alert('인증시간(3분)이 초과되었습니다. 다시 시도해주세요.');
				}
			}, 1000);
			return interval;
		},
		timerStop(Timer) {
			clearInterval(Timer);
			this.TimeCounter = 0;
		},
		prettyTime() {
			// 시간 형식으로 변환 리턴
			let time = this.TimeCounter / 60;
			let minutes = parseInt(time);
			let secondes = Math.round((time - minutes) * 60);
			return minutes.toString().padStart(2, '0') + ':' + secondes.toString().padStart(2, '0');
		},
	},
};
</script>
